import { FormContainer as Container, FormSection as Section, InputField as Input, FunctionButton } from "../../components";
import { useState, useContext, useEffect } from "react";
import FormContext from "../../context/FormContext.js";
import { useInjectFormProps } from "../../hooks/useInjectInputs.js";
import { useNavigate } from "react-router-dom";
import Spinner from "../../components/Spinner/Spinner.js";
import { usePopup } from "../../context/PopupContext";


// Have to Move later on.
import { fetchData, callAPI } from "../../api/apiClient.js";
import { validateStep } from "../../utils/pageValidator.js";

export default function SwisAccessCode() {
    const [errorMsg, setErrorMsg] = useState(null);
    const { formData, updateFormData } = useContext(FormContext);
    const { injectFormProps } = useInjectFormProps();
    const navigate = useNavigate();
    const [verifying, setVerifying] = useState(false);
    const { showPopup } = usePopup();

    // const testFunc = async () => {
    //    console.log("TEST");
    //    window.location.reload();
    // }

    // useEffect(() => {
    //    showPopup("PIN Required"
    //        , "To avoid unsolicited code requests, please enter the security PIN to unlock this section."
    //        , () => { testFunc(); });
    //    if (formData["isCanCit"] === "1") {
    //        navigate("/initial-form");
    //        return;
    //    }
    // }, []);

    const beforeSubmit = async () => {
        if (!validateStep()) {
            return;
        }
        setVerifying(true);
        setErrorMsg(null);

        const schoolCode = formData['schoolReceiving'];
        // Get SWIS responsible for school

        const assignmentDetail = await fetchData("Dtl_SWIS_School_Assignment", { School_Code: schoolCode, Disabled: 0 });
        const swisRespID = assignmentDetail.find(item => item['School_Code'] === schoolCode)['SWIS_ID'];

        const response = await callAPI("/validate-access-code", 'POST', { user_id: swisRespID, access_code: formData["swisAccessCode"] });
        if (response.data) {
            updateFormData({ isSwisAccessed: true });
            updateFormData({ swisId: swisRespID });
            navigate("/lafoip");
        } else {
            setErrorMsg("Invalid access code. Please try again.");
        }
        setVerifying(false);
    }

    // Have to Move later on.
    const [loading, setLoading] = useState(false);
    const [codeSent, setCodeSent] = useState(() => {
        return sessionStorage.getItem("codeSent") === "true";
    });
    const [timer, setTimer] = useState(() => {
        return Number(localStorage.getItem("timer")) || null;
    });

    const generateCode = async () => {
        try {
            setLoading(true);
            setTimer(30);

            localStorage.setItem("timer", 30);
            const schoolCode = formData['schoolReceiving'];
            // Get SWIS responsible for school
            const assignmentDetail = await fetchData("Dtl_SWIS_School_Assignment", { School_Code: schoolCode, Disabled: 0 });
            const swisRespID = assignmentDetail.find(item => item['School_Code'] === schoolCode)['SWIS_ID'];

            const response = await callAPI("/generate-access-code", 'POST', { user_id: swisRespID });

            console.log("Success");
        } catch (error) {
            console.error("Error:", error.message);
        } finally {
            setLoading(false);
            setCodeSent(true);
            sessionStorage.setItem("codeSent", "true"); // Store codeSent in sessionStorage
        }
    }

    useEffect(() => {
        if (timer === null || timer <= 0) {
            localStorage.removeItem("timer");
            return;
        }

        const interval = setInterval(() => {
            setTimer((prevTimer) => {
                if (prevTimer <= 1) {
                    clearInterval(interval);
                    localStorage.removeItem("timer");
                    return null;
                }
                localStorage.setItem("timer", prevTimer - 1);
                return prevTimer - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [timer]);

    return (
        <Container>
            {injectFormProps(
                <>
                    <p style={{ fontSize: "1.8rem", fontWeight: "500" }}>SWIS Required:</p>
                    <hr />
                    {/* <Section title={"Security PIN Required"}>
                        <p></p>
                        <Input type="text" inputLabel={<i>To avoid unsolicited code requests, please enter the security PIN to unlock this section.</i>} identifier={"swisUnlockPIN"} mandatory={true} />
                        <p className={"error-msg"}>{errorMsg}</p>
                        <FunctionButton type={"button"} classNames={"default-btn"} label={"Continue"} onClick={generateCode}></FunctionButton>

                    </Section> */}
                    <Section title={"Access Code"}>
                        {codeSent ? (
                            <>
                                <Input type="text" inputLabel={<i>Please enter the access code sent to your designated SWIS worker.</i>} identifier={"swisAccessCode"} mandatory={true} />
                                <p className={"error-msg"}>{errorMsg}</p>
                                {verifying ? <Spinner></Spinner> :
                                    <div>
                                        <button type="button" onClick={beforeSubmit} className="default-btn justify-center fade-in">
                                            Verify
                                        </button>
                                    </div>
                                }
                                <hr />
                                {!loading ? (
                                    <div>
                                        {codeSent &&
                                            <>  <span style={{ color: "green", fontWeight: "500" }}>Code sent! </span><br />
                                            </>
                                        }
                                        <a onClick={timer !== null ? undefined : generateCode}
                                            style={{ cursor: timer !== null ? "" : "pointer", color: timer !== null ? "gray" : "" }}
                                            disabled={timer !== null}>
                                            {timer !== null ? <p>
                                                Re-send a new code in {timer}s
                                            </p>
                                                : "RESEND CODE >"}
                                        </a>
                                    </div>
                                ) : (
                                    "Sending a new code. Please wait..."
                                )}
                            </>
                        ) : (
                            <>
                                {!loading ? (
                                    <>
                                        <p>To proceed, an access code from your designated SWIS worker is required. Click the button below to request a code.</p>
                                        <FunctionButton type={"button"} classNames={"default-btn"} label={"Send Code"} onClick={generateCode}></FunctionButton>
                                    </>
                                ) : (
                                    <Spinner label={"Sending..."}></Spinner>
                                )}
                            </>
                        )}
                    </Section>

                </>
            )}
        </Container >
    );
}
